import { combineReducers } from 'redux';
import { defineFetchForNamespace } from '../../../shared/redux/fetch';

import { fetchOrder } from '../../service';
import { Order } from '@pegasus/types/order';

export const NAME = 'fetch';
export const NAMESPACE = 'orderDetails';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    Order,
    string,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, (orderNumber: string) =>
    fetchOrder(orderNumber).then(response => response.results),
);

const getOrderDetailsReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getOrderDetailsReducer,
    getIsInitial,
    getIsLoading,
    getData as getOrder,
    fetchData as fetchOrder,
};
